import Vue from 'vue';
import template from './template.html';

export default Vue.component('about', {
  template: template,
  data () {
    return {};
  },
  mounted () {
    this.$store.dispatch('showNav');
  },
  computed: {
    content () {
      return this.$store.state.content.about || [];
    }
  }
});



// WEBPACK FOOTER //
// ./C:/projects/okinawa/be-okinawa/src/js/components/about/main.js